module.exports = __webpack_public_path__ + "img/candidate-laranja.b638c335.png";